import { Injectable } from '@angular/core';
import { FormControl } from '@angular/forms';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';

export interface LoadItemsEvent {
  pagination?: {
    search?: string;
    limit?: number;
    page?: number;
  };
  filters?: any[];
}

@Injectable({
  providedIn: 'root',
})
export class SearchPaginationService {
  /**
   * Sets up search form with debouncing
   */
  setupSearchControl(
    searchControl: FormControl,
    onSearchChange: (search: string) => void,
    debounceMs: number = 500,
  ): void {
    searchControl.valueChanges
      .pipe(debounceTime(debounceMs), distinctUntilChanged())
      .subscribe((value: string | null) => {
        onSearchChange(value || '');
      });
  }

  /**
   * Creates a load items event for search
   */
  createSearchEvent(search: string): LoadItemsEvent {
    return { pagination: { search } };
  }

  /**
   * Creates a load items event for pagination
   */
  createPaginationEvent(pageSize: number, pageIndex: number): LoadItemsEvent {
    return { pagination: { limit: pageSize, page: pageIndex + 1 } };
  }

  /**
   * Creates a load items event for filters
   */
  createFiltersEvent(filters: any[]): LoadItemsEvent {
    return { filters };
  }

  /**
   * Creates a combined load items event
   */
  createCombinedEvent(
    search?: string,
    pageSize?: number,
    pageIndex?: number,
    filters?: any[],
  ): LoadItemsEvent {
    const event: LoadItemsEvent = {};

    if (search !== undefined || pageSize !== undefined || pageIndex !== undefined) {
      event.pagination = {};
      if (search !== undefined) event.pagination.search = search;
      if (pageSize !== undefined) event.pagination.limit = pageSize;
      if (pageIndex !== undefined) event.pagination.page = pageIndex + 1;
    }

    if (filters !== undefined) {
      event.filters = filters;
    }

    return event;
  }
}
